import { Box, Button, Grid, Stack, Typography } from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

export const ClassSchedule = () => {
  return (
    <>
      {/* HERO / CLASS CARD (matches the screenshot layout) */}
      <Box
        id="classSchedule"
        sx={{
          width: "100%",
          bgcolor: "background.default",
        }}
      >
        <Grid
          container
          sx={{
            minHeight: { xs: "auto", md: 560 },
          }}
        >
          {/* LEFT PANEL (white content) */}
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                height: "100%",
                display: "flex",
                alignItems: "center",
                px: { xs: 3, sm: 6, md: 8 },
                py: { xs: 5, md: 0 },
              }}
            >
              <Box sx={{ width: "100%", maxWidth: 520 }}>
                <Typography
                  sx={{
                    fontWeight: 900,
                    letterSpacing: 1,
                    color: "text.primary",
                    opacity: 0.9,
                    fontSize: { xs: 22, sm: 26 },
                  }}
                >
                  CLASSES
                </Typography>

                <Typography
                  sx={{
                    mt: 2,
                    fontWeight: 900,
                    color: "text.primary",
                    fontSize: { xs: 42, sm: 54, md: 64 },
                    lineHeight: 1.02,
                  }}
                >
                  KANGOO JUMPS
                </Typography>

                {/* schedule block */}
                <Stack
                  direction="row"
                  spacing={2}
                  sx={{ mt: 3, alignItems: "flex-start" }}
                >
                  <CalendarMonthIcon
                    sx={{
                      color: "primary.main",
                      fontSize: { xs: 20, sm: 44 },
                      mt: 0.2,
                    }}
                  />

                  <Box>
                    <Typography
                      sx={{
                      color: "primary.main",
                        fontWeight: 900,
                        letterSpacing: 0.2,
                        fontSize: { xs: 15, sm: 26 },
                        lineHeight: 1.2,
                        textAlign: "left",
                      }}
                    >
                      WEDNESDAY 17:00 - 18:00
                      <br />
                      SUNDAY&nbsp;&nbsp;10:30 - 11:30
                    </Typography>
                  </Box>
                </Stack>

                {/* description */}
                <Typography
                  sx={{
                    mt: 3,
                    color: "text.primary",
                    fontWeight: 600,
                    fontSize: { xs: 15, sm: 16 },
                    lineHeight: 1.6,
                  }}
                >
                  The Kangoo Jumps® class combines high-intensity cardio, strength
                  training, and lots of fun, all while wearing specially designed
                  rebound shoes that let you bounce like a kangaroo.
                </Typography>

                {/* note */}
                <Typography
                  sx={{
                    mt: 2.5,
                    color: "text.secondary",
                    fontSize: { xs: 13, sm: 14 },
                    lineHeight: 1.6,
                  }}
                >
                  Not recommended during pregnancy or with back problems. Trial classes are non-refundable but rebookable by email.
                </Typography>

                {/* CTA */}
                <Button
                  href="https://book.stripe.com/28o3fFfSQ5Vu03S8ww"
                  variant="contained"
                  sx={{
                    mt: 4,
                    px: 3,
                    py: 1.6,
                    borderRadius: 2,
                    textTransform: "uppercase",
                    fontWeight: 900,
                    fontSize: { xs: 16, sm: 18 },
                    bgcolor: "primary.main",
                    color: "common.white",
                    boxShadow: "none",
                    "&:hover": {
                      bgcolor: "primary.dark",
                      boxShadow: "none",
                    },
                  }}
                  onClick={(e) => {
                    // If you still want FB pixel tracking here, keep your original fbq logic.
                    // e.preventDefault(); setTimeout(()=> window.location.href = "...", 150)
                  }}
                >
                  BOOK TRIAL CLASS 80 DKK
                </Button>
              </Box>
            </Box>
          </Grid>

          {/* RIGHT PANEL (image) */}
          <Grid item xs={12} md={6}>
            <Box
              sx={{
                height: { xs: 320, sm: 420, md: "100%" },
                minHeight: { md: 900 },
                backgroundImage: 'url("/CLASSES_PIC.jpg")',
                backgroundSize: "cover",
                backgroundPosition: { xs: "center bottom", sm: "center bottom", md: "center" },

              }}
            />
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
